const discountrequestAddDataSchema ={
    feilds: [
        {
            id: 1,
            name: 'mobile',
            title: 'Phone*',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Enter',
            icon: 'search',
            rules: [{
                test: (value) => {
                    var regex = /^\d{10}$/g;
                    if (value === null) {
                        return true;
                    }
                    else if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter valid Mobile Number'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 position-relative token-mobile'
        }, {
            id: 2,
            name: 'umr',
            title: 'UMR *',
            visible: true,
            icon: 'search',
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        }, {
            id: 3,
            name: 'ipnumber',
            title: 'IP Number *',
            visible: true,
            icon: 'search',
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        },
        {
            id: 0,
            name: 'search',
            text: 'Search',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        },
        {
            id: 4,
            name: 'patient_list',
            title: 'Select Patient',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Patient List',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null);
                        //return true;
                    },
                    message: 'Please Select Your patient'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-12'
        },
        {
            id: 9,
            name: 'doctor_name',
            title: 'Doctor Name *',
            visible: true,
            element: 'select2',
            required: true,
            type: 'select',
            placeholder: 'Select Doctor',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value !== 0 && value !== '' && value !== undefined);
                },
                message: 'Please Select Doctor'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-1 mt-2'
        }
    ]
}

const viprequestAddDataSchema ={
    feilds: [
        {
            id: 1,
            name: 'mobile',
            title: 'Phone*',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Enter',
            icon: 'search',
            rules: [{
                test: (value) => {
                    var regex = /^\d{10}$/g;
                    if (value === null) {
                        return true;
                    }
                    else if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter valid Mobile Number'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 position-relative token-mobile'
        }, {
            id: 2,
            name: 'umr',
            title: 'UMR *',
            visible: true,
            icon: 'search',
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        }, {
            id: 3,
            name: 'ipnumber',
            title: 'IP Number *',
            visible: true,
            icon: 'search',
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        },
        {
            id: 0,
            name: 'search',
            text: 'Search',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        },
        {
            id: 4,
            name: 'patient_list',
            title: 'Select Patient',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Patient List',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null);
                        //return true;
                    },
                    message: 'Please Select Your patient'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-12'
        },
        {
            id: 9,
            name: 'vip_status',
            title: 'VIP Status *',
            visible: true,
            element: 'select2',
            required: true,
            type: 'select',
            placeholder: 'Select Status',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value !== 0 && value !== '' && value !== undefined);
                },
                message: 'Please Select Status'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-1 mt-2'
        }
    ]
}

const searchData = {
    feilds: [
        {
            id: 12,
            name: 'name',
            title: 'Name',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 13,
            name: 'phonenumber',
            title: 'Phone',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 14,
            name: 'umr_number',
            title: 'UMR',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 15,
            name: 'gender',
            title: 'Gender',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 16,
            name: 'age',
            title: 'Age',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 17,
            name: 'ip',
            title: 'IP',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        },
        {
            id: 18,
            name: 'marital_status',
            title: 'Marital Status',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        },
        {
            id: 19,
            name: 'pat_address', 
            title: 'Address',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-8'
        },{
            id: 19,
            name: 'is_icu', 
            title: 'IS ICCU',
            visible: false,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }


    ]
}
export {discountrequestAddDataSchema, searchData, viprequestAddDataSchema};